var exports = {
  "Lg": "GuildSidebarSkeleton.module__navigation___OHdybm",
  "X9": "GuildSidebarSkeleton.module__detachedBanner___OHdybm",
  "GG": "GuildSidebarSkeleton.module__topSpacer___OHdybm",
  "dl": "GuildSidebarSkeleton.module__membersSection___OHdybm",
  "ne": "GuildSidebarSkeleton.module__membersSeparator___OHdybm",
  "vd": "GuildSidebarSkeleton.module__bottomDropZone___OHdybm",
  "TN": "GuildSidebarSkeleton.module__groups___OHdybm",
  "Os": "GuildSidebarSkeleton.module__group___OHdybm",
  "nM": "GuildSidebarSkeleton.module__row___OHdybm",
  "bQ": "GuildSidebarSkeleton.module__rowCategory___OHdybm",
  "me": "GuildSidebarSkeleton.module__categoryCaret___OHdybm",
  "et": "GuildSidebarSkeleton.module__rowChannel___OHdybm",
  "Ec": "GuildSidebarSkeleton.module__rowMembers___OHdybm",
  "p": "GuildSidebarSkeleton.module__channelIcon___OHdybm",
  "US": "GuildSidebarSkeleton.module__bottomSpacer___OHdybm",
};

module.exports = exports;
